import { createContext, useContext } from "react";
import { BUTTON_RADIUS } from '../../../shared/ui-constants.js';
import { useLayout } from "../../LayoutContext";
import * as modern from "./modern2";
import type { ActivityPalette } from "../../ActivityProfileModal";
export const PaletteContext = createContext<(ActivityPalette & {canvas?:string;surfaceSoft?:string;ok?:string;attention?:string}) | null>(null);
export function useTokens() {
 const {appearance:{theme}}=useLayout(), palette=useContext(PaletteContext), original=modern;
 const colors=palette?{...original.colors,background:palette.canvas??original.colors.background,surface:palette.surface,surfaceSoft:palette.surfaceSoft??original.colors.surfaceSoft,
 surfaceRaised:theme==='dark'?"#18213F":palette.surface,text:palette.ink,textMuted:palette.muted,
 border:palette.line,primary:palette.primary,primaryInk:palette.primaryText,positive:palette.ok??original.colors.positive,attention:palette.attention??original.colors.attention,critical:palette.critical,
 info:palette.primary,secondary:palette.primary,overlay:theme==='dark'?original.colors.overlay:'rgba(18,36,55,0.45)'}:original.colors;
 return {...original,colors,radius:{...original.radius,button:BUTTON_RADIUS}};
}
